// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import {
  toggleReplacementDialog,
  fetchReplacementProducts,
  fetchReplacementVariants,
} from '../../actions/productView';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';

export type Props = {
  fetchReplacementProducts: Function,
  fetchReplacementVariants: Function,
  toggleReplacementDialog: Function,
  setReplacement: Function,
  show: boolean,
  variants: any[],
  products: any[],
  variantsIsFetching: boolean,
  productsIsFetching: boolean,
  replacement?: any,
};

class ReplacementDialogContainer extends Component<Props> {
  props: Props;
  setProduct(product) {
    if (!product) {
      return;
    }
    this.props.fetchReplacementVariants(product.id);
    this.props.setReplacement({
      productId: product.id,
      productName: product.name,
      variantId: null,
      variantName: null,
    });
  }

  setVariant(variant) {
    if (!variant) {
      return;
    }
    this.props.setReplacement({
      ...this.props.replacement,
      variantId: variant.id,
      variantName: variant.name,
    });
  }

  onCloseDialog() {
    const {replacement} = this.props;
    if (!replacement || !replacement.productId || !replacement.variantId) {
      this.props.setReplacement(null);
    }

    this.props.toggleReplacementDialog(false);
  }

  onOpenDialog() {
    const {
      replacement,
      fetchReplacementProducts,
      fetchReplacementVariants,
    } = this.props;

    fetchReplacementProducts();
    if (replacement && replacement.productId) {
      fetchReplacementVariants(replacement.productId);
    }
  }

  render() {
    const {
      replacement,
      show,
      products,
      variants,
      variantsIsFetching,
      productsIsFetching,
    } = this.props;

    return (
      <div>
        <ModalDialog
          onClose={() => this.onCloseDialog()}
          onOpen={() => this.onOpenDialog()}
          show={show}>
          <LoadingIndicator
            isLoading={
              variantsIsFetching ||
              productsIsFetching
            } />
          <SelectFormInput
            input={{
              value: replacement ? replacement.productId : null,
              onBlur: _.noop,
              onChange: product => this.setProduct(product),
            }}
            label="Produkt"
            meta={{}}
            valueKey="id"
            labelKey="name"
            options={products}/>
          <SelectFormInput
            input={{
              value: replacement ? replacement.variantId : null,
              onBlur: _.noop,
              onChange: variant => this.setVariant(variant),
            }}
            label="Variant"
            meta={{}}
            valueKey="id"
            labelKey="name"
            options={variants} />
          <button
            type="button"
            className="expanded button"
            onClick={() => this.onCloseDialog()}>
              Stäng
          </button>
        </ModalDialog>
      </div>
    );
  }
}

const mapStateToProps = ({
  productView: {
    replacement: {
      show,
      products: {
        isFetching: productsIsFetching,
        list: products,
      },
      variants: {
        isFetching: variantsIsFetching,
        list: variants,
      },
    },
  },
}) => ({
  show,
  variants,
  products,
  variantsIsFetching,
  productsIsFetching,
});

const mapDispatchToProps = dispatch => ({
  fetchReplacementProducts: () =>
    dispatch(fetchReplacementProducts()),
  fetchReplacementVariants: id =>
    dispatch(fetchReplacementVariants(id)),
  toggleReplacementDialog: show =>
    dispatch(toggleReplacementDialog(show)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReplacementDialogContainer);




// WEBPACK FOOTER //
// ./src/containers/ReplacementDialogContainer/ReplacementDialogContainer.js